// extracted by mini-css-extract-plugin
module.exports = {"XL":"1920","L":"1440","M":"1024","S":"768","XS":"576"};